module.exports = __webpack_public_path__ + "media/assets/images/blog/ridurre_i_costi-small-76b51bf615eac0e141ed572921496e08.png";